export default {
  token: '',
  login: '',
  question: '',
  newPassword: '',
  answer: '',
  captchaVerified: false
};



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/formValues.js